class PreorderForm {
  constructor() {

    document.addEventListener('variant:changed', (evt) => this.updateProductForm(evt.detail.variant));
    this.script = document.getElementById('ProductInventories');

    if (!this.script) {
      return;
    }

    this.variantJson = JSON.parse(this.script.innerText);
    this.addToCart = document.getElementById('AddToCart');
    this.addToCartInnerText = this.addToCart.querySelector('.loader-button__text');

    this.strings = {
      addToCart: window.themeVariables.strings.productFormAddToCart,
      preOrder: window.themeVariables.strings.productFormPreOrder,
      soldOut: window.themeVariables.strings.productFormSoldOut,
    };
  }

  updateProductForm(variant) {
    let showPreorder = false;
    const selectedVariant = this.variantJson[variant.id];

    if (selectedVariant.policy === 'continue' && selectedVariant.inventory_quantity <= 0) {
      showPreorder = true;
    }

    if (!variant.available) {
      this.addToCartInnerText.innerText = this.strings.soldOut;
      return;
    }

    switch (showPreorder) {
      case true:
        this.addToCartInnerText.innerText = this.strings.preOrder;
        break;
      case false:
        this.addToCartInnerText.innerText = this.strings.addToCart;
        break;
    }
  }
}

export default PreorderForm;
